"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InputGroup", {
    enumerable: true,
    get: function() {
        return InputGroup;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _solid = require("@heroicons/react/solid");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var InputGroup = function(props) {
    var label = props.label, children = props.children, hasError = props.hasError, helpMsg = props.helpMsg, errorMsg = props.errorMsg, className = props.className, helpComponent = props.helpComponent, errorComponent = props.errorComponent, cornerHint = props.cornerHint, bottomHint = props.bottomHint, darkMode = props.darkMode;
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: className
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "flex justify-between"
    }, !!label && /*#__PURE__*/ _react.default.createElement("label", {
        className: (0, _classnames.default)("block text-sm font-medium", {
            "text-gray-700": !darkMode,
            "text-gray-50": darkMode
        })
    }, label), /*#__PURE__*/ _react.default.createElement("span", {
        className: (0, _classnames.default)("text-sm", {
            "text-gray-500": !darkMode,
            "text-gray-300": darkMode
        })
    }, cornerHint)), /*#__PURE__*/ _react.default.createElement("div", {
        className: "mt-1 relative"
    }, children), bottomHint ? /*#__PURE__*/ _react.default.createElement("p", {
        className: (0, _classnames.default)("mt-2 text-sm", {
            "text-gray-500": !darkMode,
            "text-gray-300": darkMode
        })
    }, bottomHint) : null, hasError && errorMsg && /*#__PURE__*/ _react.default.createElement("p", {
        className: (0, _classnames.default)("flex items-start mt-2 text-sm", {
            "text-red-600": !darkMode,
            "text-red-400": darkMode
        })
    }, /*#__PURE__*/ _react.default.createElement(_solid.ExclamationCircleIcon, {
        className: "shrink-0 h-5 w-5 mr-2 text-red-500",
        "aria-hidden": "true"
    }), " ", errorMsg), hasError && errorComponent && !errorMsg && errorComponent, !hasError && helpMsg && /*#__PURE__*/ _react.default.createElement("p", {
        className: (0, _classnames.default)("mt-2 text-sm", {
            "text-gray-500": !darkMode,
            "text-gray-300": darkMode
        })
    }, helpMsg), !hasError && helpComponent && !helpMsg && helpComponent);
};

//# sourceMappingURL=InputGroup.js.map